import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
    className?: string
    size?: 'sm' | 'md' | 'lg' | number
}

export function LoadingSpinner({ className, size = 'lg' }: LoadingSpinnerProps) {
    // Map size names to pixel values
    const sizeMap = {
        sm: 16,
        md: 24,
        lg: 32,
    }

    // Determine the final size - either from the map or directly from the number
    const finalSize = typeof size === 'string' ? sizeMap[size] : size

    return (
        <div className={cn('flex items-center justify-center', className)}>
            <Loader2 className="animate-spin text-foreground-muted" size={finalSize} strokeWidth={2} />
        </div>
    )
}
